import { formatCaseQuantity } from "./week39-view";
import type { ReportMetric } from "./week39-report";

export function Week39ReportMetric({ metric, unit, showKnownSubtotal = false }: { metric: ReportMetric; unit?: string; showKnownSubtotal?: boolean }) {
  const partial = showKnownSubtotal && metric.value === null && metric.count > metric.unknownCount;
  return <span className={`pack39-report-metric${metric.value === null ? " pack39-metric-incomplete" : ""}`}>
    <strong>{partial ? formatCaseQuantity(metric.knownValue) : metric.value === null ? "—" : formatCaseQuantity(metric.value)}</strong>
    {metric.unknownCount > 0 ? <small>{metric.unknownCount === metric.count ? "Veri doğrulanamadı" : partial ? "Doğrulanan alt toplam" : `${formatCaseQuantity(metric.knownValue)}${unit ? ` ${unit}` : ""} doğrulandı`}<br />{metric.unknownCount} satır doğrulanamadı</small> : !metric.count ? <small>Kayıt yok</small> : null}
  </span>;
}
